import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mb-4"},[_c(VRow,[_c(VCol),_c(VCol,{attrs:{"cols":"auto"}},[_c(VBtn,{attrs:{"color":"primary","data-testid":"add-new-sub-bubble-agreement-btn"},on:{"click":function($event){return _vm.$emit('on-add-new')}}},[_vm._v(_vm._s(_vm.$t('subBubbleAgreements.addSubBubbleAgreementBtnText')))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }